import { render, staticRenderFns } from "./ReciveAddrs.vue?vue&type=template&id=cd10ac92&scoped=true&"
import script from "./ReciveAddrs.vue?vue&type=script&lang=js&"
export * from "./ReciveAddrs.vue?vue&type=script&lang=js&"
import style0 from "./ReciveAddrs.vue?vue&type=style&index=0&id=cd10ac92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd10ac92",
  null
  
)

export default component.exports